export default "__VITE_ASSET__CKKyJehe__"